enum Colors  {
    BRAND_PRIMARY = '#382DC3',
    BRAND_PRIMARY_DARK = '#00008A',
    BRAND_PRIMARY_LIGHT = '#7D60FF'
}

export default Colors;